import { memo, useEffect } from 'react';
import { cartAtom, useSetValue } from '@/store';

export type NununuProps = {
  getCart: () => void;
};

export const Nununu = memo<NununuProps>((props) => {
  const { getCart } = props;

  const setCart = useSetValue(cartAtom);

  useEffect(() => {
    const targetNode = document.querySelector('cart-drawer');

    if (!targetNode) {
      console.error('Target node not found');
      return;
    }

    const checkCartOpen = () => {
      const isOpen = document.querySelector('cart-drawer')?.getAttribute('aria-hidden') === 'false';

      setCart((s) => ({
        ...s,
        isOpen,
      }));
    };

    checkCartOpen();
    const config = { attributes: true, childList: false, subtree: false };

    const callback = () => checkCartOpen();

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, [setCart]);

  useEffect(() => {
    document.addEventListener('on:cart:after-merge', getCart);

    return () => {
      document.removeEventListener('on:cart:after-merge', getCart);
    };
  }, [getCart]);

  return null;
});

Nununu.displayName = 'Nununu';
